import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ParamsSeguimientoVentas;
export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class ReporteSeguimientoVentas extends React.PureComponent<{},State> {
    constructor(props) {
        super(props);
        let hoy = new Date();
        this.state = {
            value: {
                fechaHasta: hoy,
                paquetes: 29619,
                precioPromocion: 131,
                ingresoTotal: 3880000,
                flete: 250000,
                ead: 31000,
                rad: 31000,
                seguro: 25000,
                acuse: 6000
            } as Entity
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            fechaHasta: validation.required
        };
    }

    onGenerarSeguimientoVentas = async () => {
        const reporte = await resources.RepSeguimientoVentas.Generar(this.state.value);
        await kea.download(reporte, "Reporte concentrador de ventas.xls");
    }

    render() {
        const getField = this.getField;

        const DateTime = getField(kea.DateTime);
        const Number = getField(kea.Number);
        return (
            <div>
                <kea.Title titulo="Reporte concentrador de ventas" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <DateTime field="fechaHasta" label="Fecha hasta"/>,
                    <Number field="paquetes" label="#Paquetes"/>,
                    <Number field="precioPromocion" label="Precio prom"/>,
                    <Number field="ingresoTotal" label="Ingreso total"/>,
                ])}
                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={this.onGenerarSeguimientoVentas} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteseguimientoventas/index.tsx